// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".renewal-price-group[data-v-03df06a5] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.renewal-price-group input[data-v-03df06a5] {\n    height: 38px;\n}\n.renewal-price-group select[data-v-03df06a5] {\n    padding: 0 0.1em 0 1em;\n}\n.available-packages .checkbox input[type=\"checkbox\"][data-v-03df06a5] {\n  margin-left: -20px;\n}\n", ""]);
// Exports
module.exports = exports;
